import React from 'react';
import clsx from 'clsx';
import useMedia from '../../../../hooks/useMedia';
import styles from './GridLayout.module.scss';

export const GridLayout = props => {
  const {
    children, className, minColumnWidth = 232, mobileColumnWidth = 208
  } = props;

  const contentWidth = useMedia(['(min-width: 1200px)', '(min-width: 950px)', '(min-width: 768px)', '(min-width: 680px)', '(min-width: 440px)'], [
    minColumnWidth * 5, minColumnWidth * 4, minColumnWidth * 3, mobileColumnWidth * 3, mobileColumnWidth * 2
  ], 1);

  return (
    <div className={clsx("h-100 pb-3", styles.gridLayoutContainer)}>
      <div
        className={clsx("h-100", {'justify-content-center': contentWidth === 1}, styles.gridLayout, className)}>
        {children(contentWidth === 1)}
      </div>
    </div>
  );
};

GridLayout.propTypes = {};

export default React.memo(GridLayout);
